<div class="container">
  <!-- Section Title with inline HTML (e.g., span styling) -->
  <h2 class="main-title" [innerHTML]="data.title"></h2>

  <div class="content-row">
    <div class="image-col">
      <img [src]="data.imgsrc" alt="section image" />
    </div>
    <div class="text-col">
      <div class="html-content" [innerHTML]="data.content"></div>
    </div>
  </div>
</div>
